export type ConsentKeuze = "geaccepteerd" | "geweigerd";

export const CONSENT_KEY = "eo-cookie-consent";
export const CONSENT_RECORD_KEY = "eo-cookie-consent-record";
export const CONSENT_HISTORY_KEY = "eo-cookie-consent-history";
export const CONSENT_NOTICE_VERSION = "2026-10-03";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function gtag(..._args: unknown[]) {
  window.dataLayer = window.dataLayer || [];
  // Google verwacht het echte arguments object, geen array.
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

/** Lees de eerder gemaakte keuze; null als de bezoeker nog niets koos. */
export function leesConsent(): ConsentKeuze | null {
  if (typeof window === "undefined") return null;
  try {
    const waarde = window.localStorage.getItem(CONSENT_KEY);
    const record = window.localStorage.getItem(CONSENT_RECORD_KEY);
    const versie = record ? (JSON.parse(record) as { noticeVersion?: string }).noticeVersion : null;
    if (versie !== CONSENT_NOTICE_VERSION) return null;
    return waarde === "geaccepteerd" || waarde === "geweigerd" ? waarde : null;
  } catch {
    return null;
  }
}

/**
 * Zet de standaard toestemming (Consent Mode v2) op geweigerd, vóórdat gtag.js laadt.
 * Google meet dan alleen geanonimiseerde signalen zonder cookies te plaatsen.
 */
export function zetStandaardConsent() {
  if (typeof window === "undefined") return;
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });
  gtag("set", "url_passthrough", true);
  gtag("set", "ads_data_redaction", true);
}

/** Werk de toestemming bij na een keuze van de bezoeker en onthoud die keuze. */
export function bewaarConsent(keuze: ConsentKeuze) {
  if (typeof window === "undefined") return;
  try {
    const vorigeHistorie = window.localStorage.getItem(CONSENT_HISTORY_KEY);
    const historie: unknown[] = vorigeHistorie ? JSON.parse(vorigeHistorie) as unknown[] : [];
    const record = {
      choice: keuze,
      timestamp: new Date().toISOString(),
      noticeVersion: CONSENT_NOTICE_VERSION,
      purposes: ["analytics", "advertising measurement"],
      recipients: ["Google Analytics", "Google Ads", "Google Tag Manager", "Meta (Facebook)"],
    };
    window.localStorage.setItem(CONSENT_HISTORY_KEY, JSON.stringify([...historie, record]));
    window.localStorage.setItem(CONSENT_KEY, keuze);
    window.localStorage.setItem(CONSENT_RECORD_KEY, JSON.stringify(record));
  } catch {
    /* opslag geblokkeerd: de keuze geldt dan alleen voor dit bezoek */
  }
  pasConsentToe(keuze);
  window.dispatchEvent(new Event("eo-consent-changed"));
}

/** Stuur de opgeslagen keuze door naar Google. */
export function pasConsentToe(keuze: ConsentKeuze) {
  if (typeof window === "undefined") return;
  const toegestaan = keuze === "geaccepteerd" ? "granted" : "denied";
  gtag("consent", "update", {
    ad_storage: toegestaan,
    ad_user_data: toegestaan,
    ad_personalization: toegestaan,
    analytics_storage: toegestaan,
  });
}
